import { createContext } from "react";
import type { ShellState } from "./types";

export const ShellContext = createContext<ShellState | undefined>(undefined);
